import React from "react";
import { Button, Grid } from "@mui/material";
import loginLoggo from "../../../MobileScreens/assets/images/loginLoggo.svg";

// import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import LockOpenIcon from "@mui/icons-material/LockOpen";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import corTop from "../../../MobileScreens/assets/images/corTop.png";
import corBot from "../../../MobileScreens/assets/images/corBot.png";
// import { useNavigate } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

function MobileForgotPassword() {
  // const navigate = useNavigate();

  const initialValues = {
    Email_id: "",
  };

  const validationSchema = Yup.object({
    Email_id: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);

  return (
    <>
      <div className="loginScreenMain">
        <div className="loggTopMain">
          <img src={corTop} className="corTop" />
          <img src={loginLoggo} className="loggTopMainImgM" />
          <img src={corBot} className="corBot" />
        </div>
        <div className="logContDiv">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
                <div className="wraperMobile">
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <h1 className="headingLogin">Create Password</h1>
                      <br />
                      <br />
                      <p className="confiT">Let's confirm it's you</p>
                      <br />
                      <br />
                      <span className="weWilTx">
                        We will send a Verification code by email to your email
                        Address.
                      </span>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div className="loginInptOutt">
                        <MailOutlineIcon />
                        <FormikControl
                          control="input"
                          type="text"
                          //   label="Society Code"
                          placeholder="Email"
                          //   labelclassName="reggistraLabel"
                          name="Email_id"
                          className="loginInpt"
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Button className="fullWidBt">Submit</Button>
                    </Grid>
                  </Grid>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default MobileForgotPassword;
